export default "__VITE_ASSET__B$wICj0d__"